import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Open the drain',
    desc: 'Use the 4-minute somatic sequence to clear stagnant stress hormones.'
  }, {
    num: '02',
    title: 'Silence the alarm',
    desc: 'Use the Adrenal Cocktail 2.0 at 3 PM to prevent the midnight spike.'
  }, {
    num: '03',
    title: 'Reset the clock',
    desc: 'Follow the 7-day grid to move your cortisol curve back to its natural, healthy state.'
  }];
  return <section className="bg-cream-100 py-24 px-6 relative" data-id="element-62">
      <div className="container mx-auto max-w-5xl" data-id="element-63">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-64">
          <span className="text-gold-600 font-medium tracking-widest uppercase text-sm mb-4 block" data-id="element-65">
            The Process
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-navy-900 mb-6" data-id="element-66">
            How It Works
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-67"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-68">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-px bg-gold-300/50 z-0" data-id="element-69"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-70">
              <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-lg border-4 border-cream-100 mb-8 text-gold-600 font-serif text-3xl relative" data-id="element-71">
                {step.num}
                <div className="absolute inset-0 rounded-full border border-gold-200 scale-110" data-id="element-72"></div>
              </div>

              <h3 className="font-serif text-2xl text-navy-800 mb-4" data-id="element-73">
                {step.title}
              </h3>

              <p className="text-navy-700/80 leading-relaxed font-light px-4" data-id="element-74">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}